import { configureStore } from '@reduxjs/toolkit'
import rootReducer from '@store/slice'

export type RootState = ReturnType<typeof rootReducer>
const store = configureStore({ reducer: rootReducer })
export default store
